import React from 'react';
import '../index.css';

const TermsOfService = () => {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '50px',
        animation: 'fadeInUp 0.6s ease-out'
      }}>
        <h1 style={{
          color: 'var(--text-accent)',
          fontSize: '42px',
          fontWeight: '800',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '2px'
        }}>
          Terms of Service
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '16px',
          lineHeight: '1.6'
        }}>
          Last Updated: January 12, 2026
        </p>
      </div>

      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '40px',
        border: '1px solid var(--border)',
        lineHeight: '1.8',
        fontSize: '16px',
        animation: 'fadeInUp 0.8s ease-out'
      }}>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            1. Acceptance of Terms
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Welcome to GamersUnion. By accessing or using our website at gamersunion.dev (the "Site"), 
            you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, 
            please do not use our Site.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We reserve the right to modify these Terms at any time. Changes will be effective immediately 
            upon posting to the Site. Your continued use of the Site after any changes constitutes your 
            acceptance of the new Terms.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            2. Description of Service
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion is a gaming community platform that connects gamers and indie game developers. 
            Our services include:
          </p>
          <ul style={{ color: 'var(--text)', marginBottom: '16px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Community profiles and networking</li>
            <li style={{ marginBottom: '8px' }}>Indie game showcase and discovery</li>
            <li style={{ marginBottom: '8px' }}>Game reviews and ratings</li>
            <li style={{ marginBottom: '8px' }}>Giveaways and contests</li>
            <li style={{ marginBottom: '8px' }}>Points-based reward system</li>
            <li style={{ marginBottom: '8px' }}>Gaming news and content</li>
            <li style={{ marginBottom: '8px' }}>Social media integration and verification</li>
            <li style={{ marginBottom: '8px' }}>Creator tools and utilities</li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            3. User Accounts
          </h2>
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            3.1 Account Registration
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            To access certain features, you must register for an account. You agree to provide accurate, 
            current, and complete information during registration and to keep this information up to date.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            3.2 Account Security
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You are responsible for maintaining the confidentiality of your account credentials and for all 
            activities that occur under your account. You must immediately notify us of any unauthorized use 
            of your account or any other security breach.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            3.3 Account Types
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Users can register as regular gamers or indie game developers. Account type changes may require 
            admin approval. You must not misrepresent your account type or create multiple accounts to 
            circumvent our policies.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            4. User Conduct
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You agree not to use the Site to:
          </p>
          <ul style={{ color: 'var(--text)', marginBottom: '16px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Violate any applicable laws or regulations</li>
            <li style={{ marginBottom: '8px' }}>Harass, abuse, threaten, or intimidate other users</li>
            <li style={{ marginBottom: '8px' }}>Post false, misleading, or fraudulent content</li>
            <li style={{ marginBottom: '8px' }}>Spam or engage in any automated use of the system</li>
            <li style={{ marginBottom: '8px' }}>Attempt to manipulate the points system or giveaways</li>
            <li style={{ marginBottom: '8px' }}>Upload viruses, malware, or any malicious code</li>
            <li style={{ marginBottom: '8px' }}>Impersonate another person or entity</li>
            <li style={{ marginBottom: '8px' }}>Collect or harvest user information without consent</li>
            <li style={{ marginBottom: '8px' }}>Interfere with the proper functioning of the Site</li>
            <li style={{ marginBottom: '8px' }}>Post content that infringes on intellectual property rights</li>
            <li style={{ marginBottom: '8px' }}>Share inappropriate, offensive, or NSFW content</li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            5. User Content
          </h2>
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            5.1 Ownership and License
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You retain ownership of any content you submit, post, or display on the Site ("User Content"). 
            By submitting User Content, you grant GamersUnion a worldwide, non-exclusive, royalty-free license 
            to use, reproduce, modify, adapt, publish, and display such content in connection with operating 
            and promoting the Site.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            5.2 Content Responsibility
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You are solely responsible for your User Content. You represent and warrant that you own or have 
            the necessary rights to submit your User Content and that it does not violate any third-party rights 
            or applicable laws.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            5.3 Content Moderation
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We reserve the right, but are not obligated, to monitor, review, and remove any User Content at our 
            sole discretion. Content submitted by indie developers and certain user posts may require admin 
            approval before being publicly displayed.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            6. Points and Rewards System
          </h2>
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            6.1 Earning Points
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Users can earn points through various activities on the Site, including writing reviews, daily 
            logins, community engagement, and maintaining activity streaks. Points have no cash value and 
            cannot be exchanged for money.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            6.2 Point Usage and Redemption
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Points can be redeemed in our shop for game keys, profile features, and other rewards. We reserve 
            the right to modify point values, redemption options, and the availability of rewards at any time 
            without prior notice.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            6.3 Point Abuse
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Any attempt to manipulate, exploit, or abuse the points system (including but not limited to 
            creating multiple accounts, using bots, or engaging in coordinated behavior) will result in 
            point forfeiture and account termination.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            7. Giveaways and Contests
          </h2>
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            7.1 Participation
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Users can participate in giveaways hosted by developers, creators, or other community members. 
            Entry may require spending points or meeting specific eligibility requirements as stated in each 
            giveaway.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            7.2 Winner Selection
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Winners are selected randomly using a secure random generator. Winners will be notified via email 
            and on-site notification and must claim their prize within the specified timeframe (typically 48-72 
            hours) or a new winner will be drawn.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            7.3 Prize Delivery
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Giveaway hosts are responsible for delivering prizes to winners. GamersUnion acts as a platform 
            facilitator and is not responsible for prize fulfillment, though we may assist in mediating disputes.
          </p>
          
          <h3 style={{ color: 'var(--primary)', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
            7.4 Giveaway Rules
          </h3>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Users hosting giveaways must comply with all applicable laws and regulations. Fraudulent giveaways 
            or failure to deliver promised prizes will result in account termination and may be reported to 
            appropriate authorities.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            8. Intellectual Property
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            The Site and its original content, features, and functionality are owned by GamersUnion and are 
            protected by international copyright, trademark, and other intellectual property laws. You may not 
            reproduce, distribute, modify, or create derivative works of our content without explicit permission.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Game titles, logos, and other content referenced on the Site are the property of their respective 
            owners. We use these for informational purposes only and do not claim ownership.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            9. DMCA and Copyright Infringement
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We respect intellectual property rights and expect our users to do the same. If you believe that 
            content on our Site infringes your copyright, please contact us at{' '}
            <a href="mailto:alonelycat31@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
              alonelycat31@gmail.com
            </a>{' '}
            with:
          </p>
          <ul style={{ color: 'var(--text)', marginBottom: '16px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Identification of the copyrighted work</li>
            <li style={{ marginBottom: '8px' }}>Location of the infringing material on our Site</li>
            <li style={{ marginBottom: '8px' }}>Your contact information</li>
            <li style={{ marginBottom: '8px' }}>A statement of good faith belief that the use is not authorized</li>
            <li style={{ marginBottom: '8px' }}>A statement that the information is accurate and you are authorized to act</li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            10. Third-Party Services and Links
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Our Site integrates with third-party services (Steam, Discord, Twitter, YouTube, Twitch, etc.) and 
            may contain links to external websites. We are not responsible for the content, privacy practices, 
            or terms of service of these third parties. Your use of third-party services is at your own risk.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We may display advertisements or affiliate links. We may earn commissions from purchases made through 
            these links, as disclosed in our Affiliate Disclosure page.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            11. Disclaimer of Warranties
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            THE SITE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER 
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A 
            PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We do not warrant that the Site will be uninterrupted, secure, or error-free. We do not guarantee 
            the accuracy, reliability, or completeness of any content on the Site.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            12. Limitation of Liability
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            TO THE FULLEST EXTENT PERMITTED BY LAW, GAMERSUNION SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
            SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR USE, ARISING 
            OUT OF OR IN CONNECTION WITH YOUR USE OF THE SITE.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU EXCEED THE AMOUNT YOU PAID TO US IN THE PAST TWELVE 
            MONTHS, OR ONE HUNDRED DOLLARS ($100), WHICHEVER IS LESS.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            13. Indemnification
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You agree to indemnify, defend, and hold harmless GamersUnion, its operators, affiliates, and 
            partners from any claims, damages, losses, liabilities, and expenses (including legal fees) arising 
            from your use of the Site, violation of these Terms, or infringement of any third-party rights.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            14. Account Termination
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We reserve the right to suspend or terminate your account at any time, with or without notice, for 
            any reason, including but not limited to violations of these Terms. You may also request account 
            deletion at any time through your account settings.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Upon termination, your right to use the Site will immediately cease. We may retain certain 
            information as required by law or for legitimate business purposes.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            15. Dispute Resolution
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Any disputes arising from these Terms or your use of the Site shall be resolved through informal 
            negotiation first. If a dispute cannot be resolved informally, it shall be governed by the laws of 
            your jurisdiction, and you agree to submit to the personal jurisdiction of the courts in that location.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            16. Changes to Service
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We reserve the right to modify, suspend, or discontinue any part of the Site at any time without 
            notice. We will not be liable to you or any third party for any modification, suspension, or 
            discontinuation of the Site.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            17. Severability
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            If any provision of these Terms is found to be unenforceable or invalid, that provision shall be 
            limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain 
            in full force and effect.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            18. Entire Agreement
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            These Terms, together with our Privacy Policy and any other legal notices published on the Site, 
            constitute the entire agreement between you and GamersUnion regarding your use of the Site.
          </p>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            19. Contact Information
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            If you have any questions about these Terms of Service, please contact us:
          </p>
          <ul style={{ color: 'var(--text)', paddingLeft: '24px', listStyle: 'none' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Email:</strong>{' '}
              <a href="mailto:alonelycat31@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                alonelycat31@gmail.com
              </a>
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Twitter:</strong>{' '}
              <a 
                href="https://twitter.com/AlonelyCat31" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: 'var(--primary)', textDecoration: 'none' }}
              >
                @AlonelyCat31
              </a>
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Website:</strong>{' '}
              <a href="https://gamersunion.dev" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                gamersunion.dev
              </a>
            </li>
          </ul>
        </section>

        <div style={{
          marginTop: '40px',
          padding: '20px',
          backgroundColor: 'rgba(var(--primary-rgb), 0.1)',
          borderRadius: '12px',
          borderLeft: '4px solid var(--primary)'
        }}>
          <p style={{ color: 'var(--text)', fontSize: '14px', margin: 0 }}>
            By using GamersUnion, you acknowledge that you have read, understood, and agree to be bound by 
            these Terms of Service.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
